import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { QueryKeys } from "@/Service/Api/V1/QueryKeys/QueryKeys";
import { TeamsApiClient } from "@/Service/Api/V1/ApiClients/TeamsApiClient";
import { GetTeamsRequest } from "@/Stub/V1";

export type useGetClientsParams = {
    requestParams?: GetTeamsRequest
    enabled?: boolean
    savePreviousData?: boolean
};

export const useGetTeams = ({ requestParams, enabled, savePreviousData }: useGetClientsParams = {}) => {
    return useQuery({
        ...QueryKeys.teams.list(requestParams),
        queryFn: async () => await TeamsApiClient.getTeams(requestParams),
        enabled,
        gcTime: 0,
        placeholderData: savePreviousData ? keepPreviousData : undefined
    });
};